module.exports = __webpack_public_path__ + "img/chevron-double-down.76627e3c.svg";